import { SubmitButton, SubmitButtonContainer } from "./styled";

export const SubmitButtons = () => {
    return (
        <SubmitButtonContainer>
            <SubmitButton type="primary" htmlType="submit">Сохранить</SubmitButton>
        </SubmitButtonContainer>
    );
}